function About() {

  return (

    <section id="about" className="reveal">

      <div className="section-title">
        <h2>About</h2>
      </div>

      <div className="about-container">

        <div className="about-image">
          <img src="/images/profile.jpg" alt="Profile" />
        </div>

        <div className="about-text">

          <p>
            I am a <span className="highlight">
            Computer Science and Engineering student specializing in Artificial Intelligence and Machine Learning
            </span> at <span className="highlight">
            Vignan's Foundation for Science, Technology & Research
            </span>.
          </p>

          <p>
            My work sits at the intersection of <span className="highlight">technology and creativity</span>,
            where development, design, and digital art come together to create engaging digital experiences.
          </p>

          <p>
            I explore multiple areas including <span className="highlight">
            web development, UI/UX design, 3D modelling, and digital content creation
            </span>.
          </p>

          <p>
            I believe the most impactful digital experiences happen when
            <span className="highlight"> engineering meets creativity</span>.
          </p>

        </div>

      </div>

    </section>

  );

}

export default About;